import { MapModuleLayer, MapState, MappingEngine } from "@iventis/map-engine/src/types/store-schema";
import { AssetType } from "@iventis/domain-model/model/assetType";
import { SavedMapView } from "@iventis/domain-model/model/savedMapView";
import { Map } from "@iventis/domain-model/model/map";
import { WaitingForEvent } from "@iventis/types/loading.types";
import { ViewByStatus } from "@iventis/map-engine/src/types/layer-view-by";
import { MapLayer } from "@iventis/domain-model/model/mapLayer";
import { OptionalExceptFor } from "@iventis/types/useful.types";
import { UnitOfMeasurement } from "@iventis/domain-model/model/unitOfMeasurement";
import { MapSitemapConfig } from "@iventis/domain-model/model/mapSitemapConfig";
import { AnalysisType } from "@iventis/domain-model/model/analysisType";
import { Sitemap } from "@iventis/domain-model/model/sitemap";
import { Asset } from "@iventis/domain-model/model/asset";

interface RestrictedCdnSignature {
    url: string;
    signature: string;
    expiry: string;
    assetVersion: Date;
}

export interface DomainMapState extends MapState {
    layers?: {
        value: DomainLayer[];
        stamp: string;
    };
    analysisLayers?: {
        value: DomainLayer[];
        stamp: string;
    };
    unitOfMeasurement: {
        value: UnitOfMeasurement;
        stamp: string;
    };
}

export interface MapGlobalState {
    savedMapViewWizard: SavedMapViewWizard;
    waitingFor: WaitingForEvent[];
    objectsChangesSaving: string[];
    /** Map object ids, where the geometry is not valid and is still in a state of composition */
    incompleteDrawingObjects: string[];
    mapName: string;
    savedMapViews: SavedMapView[];
    savedMapViewDefault: string;
    savedBackgroundDefault: string;
    levels: Level[];
    isPlacingGeometry: boolean;
    sitemaps: Sitemap[];
    sitemapsInView: Sitemap[];
    mapModule: DomainMapState;
    showMapObjectInformation: boolean;
    signatures: RestrictedCdnSignature[];
    mappingEngine: MappingEngine;
    drawingToolTip: "click-to-draw-again" | null;
    savedMapTooltip: boolean;
    isMapPanningAfterSearch: boolean;
    creatingObjects?: string[];
    failedToGetMap: "default" | "not_found" | null;
    showRoutePlanner: boolean;
    sitemapConfigs: MapSitemapConfig[];
    layersWithTemporaryVisibilityValue: string[];
    selectedAnalysisTool: AnalysisType;
    showBookmarks: boolean;
    takingScreenshot: boolean;
    mapBackgrounds: Asset[];
    mapBackgroundsThatFailedToLoad: string[];
    webGLSupported: boolean;
}

type BasemapType = AssetType.MapBackground;

export type CreateMapRequestPayload = OptionalExceptFor<Map, "name" | "parentId" | "shared">;

export type GetBasemapRequestPayload = { id: string; type: BasemapType };

export interface DomainLayer extends MapLayer, MapModuleLayer {
    viewBy: ViewByStatus;
    viewById?: string;
}

export interface Level {
    index: number;
    name: string;
    abbreviation: string;
}

interface SavedMapViewWizard {
    stage: SavedMapViewStages;
    mapViewId: string;
}

export enum SavedMapViewStages {
    NONE = "NONE",
    NOTIFICATION = "NOTIFICATION",
    FORM = "FORM",
}
